import { Controller } from 'stimulus';

export default class AccordionController extends Controller {
  static targets = ['content'];

  opened = false;

  contentMinHeight = '0px';

  contentMaxHeight = '200vh';

  connect() {
    this.loadHandler = () => window.requestAnimationFrame(this.recalculate);
    window.addEventListener('turbolinks:load', this.loadHandler);
    window.addEventListener('load', this.loadHandler);
    this.opened = this.element.classList.contains('opened');
    this.recalculate();
    this.element.addEventListener('force-close', this.onForceClose);
  }

  disconnect() {
    window.removeEventListener('turbolinks:load', this.loadHandler);
    window.removeEventListener('load', this.loadHandler);
    this.element.removeEventListener('force-close', this.onForceClose);
  }

  recalculate = () => {
    this.contentTarget.style.maxHeight = 'none';
    this.contentMaxHeight = window.getComputedStyle(this.contentTarget).height;
    const { showNumber } = this.contentTarget.dataset;
    const lastElement = this.contentTarget.children[showNumber - 1];

    if (showNumber && lastElement) {
      const { top } = this.contentTarget.children[0].getBoundingClientRect();
      const { bottom } = lastElement.getBoundingClientRect();
      const style = window.getComputedStyle(lastElement);

      this.contentMinHeight = `${bottom - top + parseFloat(style.marginTop) + parseFloat(style.marginBottom)}px`;
    }

    if (this.contentMaxHeight === 'auto') {
      // Something went wrong — save the fallback max-height value:
      this.contentMaxHeight = '200vh';
    }

    this.contentTarget.style.maxHeight = this.opened
      ? this.contentMaxHeight
      : this.contentMinHeight;
  };

  updateParentAccordions(calcDelta) {
    let { element } = this;

    do {
      element = element.parentElement;
      if (
        element && element.hasAttribute('data-accordion-target')
        && element.dataset.accordionTarget.indexOf('content') >= 0
      ) {
        const { maxHeight } = window.getComputedStyle(element);
        element.style.maxHeight = `calc(${maxHeight} + ${calcDelta})`;
      }
    } while (element);
  }

  closeChildAccordions() {
    const accordions = this.element.querySelectorAll('[data-controller="accordion"].opened');
    for (let i = 0; i < accordions.length; i++) {
      accordions[i].dispatchEvent(new CustomEvent('force-close'));
    }
  }

  open() {
    this.element.classList.add('opened');
    this.contentTarget.style.maxHeight = this.contentMaxHeight;
    this.updateParentAccordions(`${this.contentMaxHeight} - ${this.contentMinHeight}`);
    this.opened = true;
  }

  close() {
    this.element.classList.remove('opened');
    this.contentTarget.style.maxHeight = this.contentMinHeight;
    this.updateParentAccordions(`${this.contentMinHeight} - ${this.contentMaxHeight}`);
    this.closeChildAccordions();
    this.opened = false;
  }

  toggle() {
    if (this.opened) {
      this.close();
    } else {
      this.open();
    }
  }

  onForceClose = () => {
    this.opened = false;
    this.element.classList.remove('opened');
    this.contentTarget.style.maxHeight = this.contentMinHeight;
  };
}
